import { action, computed, makeObservable, observable } from 'mobx';
import { UiStore } from './ui';
import { IGetApiType } from '../REST';
import { IAboutInfo, IFeatureFlags, IProfileSettings, IUser } from '../interfaces';

export class ProfileStore {
    private constructor() {
        makeObservable(this);
    }

    private static instance: ProfileStore;
    public static getInstance(): ProfileStore {
        if (!ProfileStore.instance) {
            ProfileStore.instance = new ProfileStore();
        }
        return ProfileStore.instance;
    }

    initProfileStore: IUser = {
        id: '',
        companyId: undefined,
        firstName: '',
        lastName: '',
        email: '',
        userType: '',
        func: '',
    };

    @observable profile: IUser = this.initProfileStore;
    @action setProfile(profile: IUser): void {
        this.profile = profile;
    }

    @observable about: IAboutInfo = {};
    @action setAbout(about: IAboutInfo): void {
        this.about = about;
    }
    @action cleanAbout(): void {
        this.about = {};
    }

    @observable spinners: IGetApiType[] = ['GET_USER_PROFILE', 'GET_WHO_AM_I'];
    @computed get isSpinning(): boolean {
        return UiStore.getInstance().isFoundSpinner(this.spinners);
    }

    @observable profileFeatureFlags: IFeatureFlags = {};
    @action setProfileFeatureFlags(featureFlags: IFeatureFlags): void {
        this.profileFeatureFlags = featureFlags;
    }

    @observable profileSettings: IProfileSettings = {};
    @action setProfileSettings(settings: IProfileSettings): void {
        this.profileSettings = settings;
    }

    @observable isImpersonating = false;

    @action setIsImpersonating(isImpersonating: boolean): void {
        this.isImpersonating = isImpersonating;
    }

    @action cleanStore(): void {
        this.profile = this.initProfileStore;
        this.about = {};
        this.profileFeatureFlags = {};
    }
}
